/**
 * This file exports variables that are used as defaults for the crosstab group.
 */
export const DATA_UPDATE_COUNTER = 0;

export const DEFAULT_LAYER_TYPE = 'cartesian';

export const BORDER_WIDTH = {
    default: 2,
    facet: 1
};
